<button
  class="theme-toggle glass-card"
  [ngClass]="{ 'icon-only': iconOnly }"
  (click)="toggle()"
  [attr.aria-label]="'Toggle theme to ' + (currentTheme === 'light' ? 'dark' : 'light')"
>
  <ion-icon [name]="currentTheme === 'light' ? 'moon' : 'sunny'"></ion-icon>
  <span *ngIf="!iconOnly">{{ currentTheme === 'light' ? 'Dark' : 'Light' }} mode</span>
</button>
